<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-2 mb-8">
      <v-row
        align="center"
        justify="center"
        class="px-4 mb-8"
      >
        <v-col
          cols="12"
          md="8"
        >
          <v-card>
            <v-form
              @submit.prevent="save()"
              ref="form"
              lazy-validation
            >
              <v-card-text>
                <v-row>
                  <div class="dropzone-hero-img ma-6"
                    @dragover.prevent
                    @drop.prevent="onFileChange('heroImg', $event)"
                    @click="$refs.heroImageFile.click()"
                  >
                    <img v-if="heroImg" :src="isNotHeroImg() ? heroImg : `${this.baseURL}/img/users/350/${heroImg}`"/>
                    <div v-else class="text-center">
                      <div class="text-subtitle-1 mx-2">Drop file here or click to upload image</div>
                      <div class="caption font-weight-medium">Maximum upload file size: 5MB</div>
                    </div>

                    <v-btn
                      v-if="heroImg"
                      @click.stop="removeHeroImage()"
                      small
                      icon
                      class="remove-image-btn"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <input type="file" ref="heroImageFile" style="display: none" @change="onFileChange('heroImg', $event)">
                  </div>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="user.first_name"
                      label="First Name"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="user.last_name"
                      label="Last Name"
                      class="mx-2"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="invite.award.name"
                      label="Award"
                      class="mx-2"
                      filled
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="user.about"
                      label="About"
                      rows="2"
                      class="mx-2"
                      filled
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="user.email"
                      label="Email"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="user.role"
                      :items="['admin', 'user']"
                      label="Role"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="red lighten-5 red--text text--darken-2"
                  depressed
                  class="mx-4 mb-6"
                  @click="callConfirmDeleteUserDialog()"
                >
                  Delete
                </v-btn>
                <v-spacer/>
                <v-btn
                  color="accent"
                  depressed
                  class="mx-4 mb-6"
                  type="submit"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>

      <!-- Confirm Delete User Dialog-->
      <confirm-delete-user-dialog
        ref="confirmDeleteUserDialog"
        :user="user"
      ></confirm-delete-user-dialog>

    </div>
  </div>
</template>

<script>
import ConfirmDeleteUserDialog from '@/components/users/ConfirmDeleteUserDialog.vue'
import Loader from '@/components/Loader'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'Edit',

  mixins: [messagesMixin],

  components: {
    ConfirmDeleteUserDialog,
    Loader
  },

  data () {
    return {
      heroImg: '',
      pageLoaded: false,
      invite: {
        award: {
          name: ''
        }
      },
      user: {
        id: '',
        about: '',
        award: '',
        email: '',
        first_name: '',
        last_name: ''
      }
    }
  },

  mounted () {
    Promise.all([
      this.getInvite()
    ])
      .then(() => {
        this.pageLoaded = true
      })
  },

  methods: {
    callConfirmDeleteUserDialog () {
      this.$refs.confirmDeleteUserDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.deleteInvite()
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    deleteInvite () {
      this.$http.delete('/invites/' + this.invite.id)
        .then(({ data }) => {
          this.$router.push({ name: 'users.index' })

          this.showSuccessMessage('User was deleted successfully!')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getInvite () {
      return this.$http.get('/invites/' + this.$route.params.id)
        .then(({ data }) => {
          this.invite = data.invite

          this.user = this.invite.user

          this.heroImg = this.user.image
        })
        .catch(error => {
          console.log(error)
        })
    },

    isNotHeroImg () {
      return !this.heroImg.match(/.(jpg|jpeg|png)$/i)
    },

    onFileChange (img, e) {
      const files = e.target.files || e.dataTransfer.files

      if (!files[0].name.match(/.(jpg|jpeg|png)$/i)) {
        this.showCustomErrorMessage('Ooops! You can upload jpg, jpeg, png extensions files only', 3000)
        return
      }

      if (files[0].size > 5242880) {
        this.showCustomErrorMessage('Ooops! Maximum upload file size: 5MB', 3000)
        return
      }

      if (!files.length) return

      const file = files[0]

      const reader = new FileReader()
      reader.onload = f => {
        // f.target.result contains the base64 encoding of the image
        this[img] = f.target.result
      }
      reader.readAsDataURL(file)
    },

    removeHeroImage () {
      this.heroImg = ''
    },

    save () {
      this.user.image = this.heroImg

      this.$http.put('/users/' + this.user.id, this.user)
        .then(({ data }) => {
          this.showSuccessMessage('User was updated successfully!')
        })
        .catch(error => {
          console.log(error)
          this.showErrorMessage()
        })
    }
  }
}
</script>

<style scoped>
  .dropzone-hero-img {
    width: 100%;
    height: 200px;
    position: relative;
    border: 2px dashed rgba(0,0,0,0.12);
    color: rgba(0, 0, 0, 0.6);
    display: grid;
    place-items: center;
  }

  .dropzone-hero-img:hover {
    border: 2px dashed rgba(23,122,152,0.4);;
    background-color: #E8F2F4;
    cursor: pointer;
    color: #177a97;
  }

  .dropzone-hero-img img {
    display: block;
    margin: auto;
    max-height: 196px !important;
    max-width: 100% !important;
  }

  .remove-image-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }
</style>
